import { render, staticRenderFns } from "./InsightPage.vue?vue&type=template&id=2063ed7c&"
import script from "./InsightPage.vue?vue&type=script&lang=ts&"
export * from "./InsightPage.vue?vue&type=script&lang=ts&"
import style0 from "./InsightPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports